import { div } from "framer-motion/client";
import "../style/ContactForm.scss";

export default function ContactForm() {
    return (
      <div className="contact-container1">
        <div className="contact-container-tilile">
          <h1>Send us an email
          </h1>
          <p>We’d love to hear from you Whether you have a question, want to discuss a project, need assistance, Or simply to just chat our team is here to help. Reach out to us today, and let’s start a conversation about how we can bring your ideas to life.</p>
        </div>
      <div className="contact-container">
        {/* Left - Form Section */}
        <div className="form-section">
          <h2>Get in touch</h2>
          <form action="https://formsubmit.co/contact@evas-agency.com" method="POST">
          <div className="input-group">
            <input type="text" name="name" placeholder="Name" required />
            <input type="email" name="email" placeholder="Email" required />
          </div>
          
          <input type="tel" name="phone" placeholder="Phone Number" required />
          <input type="text" name="subject" placeholder="Subject" required />
          <textarea name="message" placeholder="Message" rows={4} required></textarea>
          <button type="submit">Send Message</button>
        </form>
        </div>
  
        {/* Right - Contact Info Section */}
        <div className="contact-section">
          <h2>Contact us</h2>
          <p><strong>📍 Address:</strong> Morocco-Tanger</p>
          <p><strong>📞 Phone:</strong> +212681538070 </p>
          <p><strong>✉️ Email:</strong> contact@evas-agency.com</p>
          <p><strong>🌍 Website:</strong> evas-agency.com </p>
        </div>
      </div>
      </div>
    );
  }